import { Button } from "../Button";
import Modal from "../Modal";
import { EntityItem, EntityLabels, getEntityLabels } from "./types";

export function EntityConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  loading,
  item,
  labels,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  item: EntityItem | null;
  labels: EntityLabels;
}) {
  const { deleteTitle } = getEntityLabels(labels);
  return (
    <Modal
      title={deleteTitle}
      contentClassName="!w-[400px] [&>.title-container]:!px-0"
      isOpen={isOpen}
      handleModal={onClose}
    >
      <div className="flex flex-col mt-2 gap-4">
        <p className="text-[15px] text-text2">
          Are you sure you want to delete <span className="font-bold">{item?.name}</span>?
        </p>
        <div className="flex justify-end gap-2">
          <Button
            variant="outline"
            onClick={onClose}
            className="bg-background3 px-5 h-[35px] !rounded-full !border-0"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
            className="px-5 py-0 !h-[35px] !rounded-full"
          >
            Yes, Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
